import "core-js/modules/es.array.reverse.js";
var _class, _MapboxVectorTileLoadableStratum, _class2, _MapboxVectorTileCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { computed, makeObservable, runInAction } from "mobx";
import { GeomType, LineSymbolizer, PolygonSymbolizer } from "protomaps-leaflet";
import loadJson from "../../../Core/loadJson";
import TerriaError from "../../../Core/TerriaError";
import ProtomapsImageryProvider from "../../../Map/ImageryProvider/ProtomapsImageryProvider";
import { mapboxStyleJsonToProtomaps } from "../../../Map/Vector/Protomaps/mapboxStyleJsonToProtomaps";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import LegendTraits, { LegendItemTraits } from "../../../Traits/TraitsClasses/LegendTraits";
import MapboxVectorTileCatalogItemTraits from "../../../Traits/TraitsClasses/MapboxVectorTileCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
let MapboxVectorTileLoadableStratum = (_class = (_MapboxVectorTileLoadableStratum = class MapboxVectorTileLoadableStratum extends LoadableStratum(MapboxVectorTileCatalogItemTraits) {
  constructor(item, styleJson) {
    super();
    this.item = item;
    this.styleJson = styleJson;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new MapboxVectorTileLoadableStratum(newModel, this.styleJson);
  }
  static async load(item) {
    let styleJson;
    if (item.styleUrl) {
      try {
        styleJson = await loadJson(proxyCatalogItemUrl(item, item.styleUrl));
      } catch (e) {
        throw TerriaError.from(e, "Failed to load style JSON from url ".concat(item.styleUrl));
      }
    }
    return new MapboxVectorTileLoadableStratum(item, styleJson);
  }
  get style() {
    return this.styleJson;
  }
  get opacity() {
    return 1;
  }
  get legends() {
    if (!this.item.fillColor && !this.item.lineColor) return [];
    return [createStratumInstance(LegendTraits, {
      items: [createStratumInstance(LegendItemTraits, {
        color: this.item.fillColor,
        outlineColor: this.item.lineColor,
        outlineWidth: this.item.lineColor ? 1 : undefined,
        title: this.item.name
      })]
    })];
  }
}, _defineProperty(_MapboxVectorTileLoadableStratum, "stratumName", "MapboxVectorTileLoadable"), _MapboxVectorTileLoadableStratum), _applyDecoratedDescriptor(_class.prototype, "legends", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "legends"), _class.prototype), _class);
StratumOrder.addLoadStratum(MapboxVectorTileLoadableStratum.stratumName);
let MapboxVectorTileCatalogItem = (_class2 = (_MapboxVectorTileCatalogItem = class MapboxVectorTileCatalogItem extends MappableMixin(UrlMixin(CatalogMemberMixin(CreateModel(MapboxVectorTileCatalogItemTraits)))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return MapboxVectorTileCatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.mapboxVectorTile.name");
  }
  async forceLoadMetadata() {
    const stratum = await MapboxVectorTileLoadableStratum.load(this);
    runInAction(() => {
      this.strata.set(MapboxVectorTileLoadableStratum.stratumName, stratum);
    });
  }
  get parsedJsonStyle() {
    if (this.style) {
      return mapboxStyleJsonToProtomaps(this.style, {});
    }
    return undefined;
  }

  /** Convert traits into paint rules:
   * - `layer` and `fillColor`/`lineColor` into simple rules
   * - `parsedJsonStyle`
   */
  get paintRules() {
    const rules = [];
    if (this.layer) {
      if (this.fillColor) {
        rules.push({
          dataLayer: this.layer,
          symbolizer: new PolygonSymbolizer({
            fill: this.fillColor
          }),
          minzoom: this.minimumZoom,
          maxzoom: this.maximumZoom,
          // Only apply polygon/fill symbolizer to polygon features (otherwise it will also apply to line features)
          filter: (_z, f) => f.geomType === GeomType.Polygon
        });
      }
      if (this.lineColor) {
        rules.push({
          dataLayer: this.layer,
          symbolizer: new LineSymbolizer({
            color: this.lineColor
          }),
          minzoom: this.minimumZoom,
          maxzoom: this.maximumZoom
        });
      }
    }
    if (this.parsedJsonStyle) {
      rules.push(...this.parsedJsonStyle.paintRules);
    }
    return rules;
  }
  get labelRules() {
    if (this.parsedJsonStyle) {
      return this.parsedJsonStyle.labelRules;
    }
    return [];
  }
  get imageryProvider() {
    if (this.url === undefined) {
      return;
    }
    return new ProtomapsImageryProvider({
      terria: this.terria,
      // Use the URL as the id, this is needed for backward compatibility with MapboxImageryProvider, for when picking features (as it uses the URL as the id)
      id: this.url,
      data: proxyCatalogItemUrl(this, this.url),
      minimumZoom: this.minimumZoom,
      maximumNativeZoom: this.maximumNativeZoom,
      maximumZoom: this.maximumZoom,
      rectangle: this.cesiumRectangle,
      credit: this.attribution,
      paintRules: this.paintRules,
      labelRules: this.labelRules,
      idProperty: this.idProperty
    });
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get mapItems() {
    if (this.isLoadingMapItems || this.imageryProvider === undefined) {
      return [];
    }
    return [{
      imageryProvider: this.imageryProvider,
      show: this.show,
      alpha: this.opacity,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    }];
  }
}, _defineProperty(_MapboxVectorTileCatalogItem, "type", "mvt"), _MapboxVectorTileCatalogItem), _applyDecoratedDescriptor(_class2.prototype, "parsedJsonStyle", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "parsedJsonStyle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "paintRules", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "paintRules"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "labelRules", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "labelRules"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "imageryProvider"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _class2);
export default MapboxVectorTileCatalogItem;